const permissaoGridConfig = {
    idField: "idCadastros",
    serviceMethod: "getPermissao",
  columns: [
    { header: "Usuário", field: "NOME" },
    { header: "Perfil", field: "nome" },
    { header: "Permissão", field: "descricao" }
  ]    

};

export default permissaoGridConfig;